import GlobeIcon from "@redotech/redo-icons/globe-02.svg";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { localizationConfig } from "./localization-config";
import * as styles from "./locale-selector.module.css";
import { ALL_LOCALES, getLocaleName } from "./locales";

interface LocaleSelectorProps {
  onLocaleChange?: (locale: string) => void;
}

export const LocaleSelector = memo(function LocaleSelector({
  onLocaleChange,
}: LocaleSelectorProps) {
  const { t, i18n } = useTranslation();

  if (!localizationConfig.isEnabled()) {
    return null;
  }

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const locale = e.target.value;
      void i18n.changeLanguage(locale);
      onLocaleChange?.(locale);
    },
    [i18n, onLocaleChange],
  );

  return (
    <div className={styles.container}>
      <div className={styles.button}>
        <GlobeIcon className={styles.icon} height={16} width={16} />
      </div>
      <select
        aria-label={t("Select language")}
        className={styles.select}
        onChange={handleChange}
        value={i18n.language}
      >
        {ALL_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {getLocaleName(locale)}
          </option>
        ))}
      </select>
    </div>
  );
});
